'use strict'

const createSwiper = _ => new Swiper('.swiper-detail-container', {
    slidesPerView: 1,
    autoplay: {
        delay: 2500,
        disableOnInteraction: false,
    },
    pagination: {
        el: '.swiper-pagination',
        clickable: true,
    },
});

const changeSlide = swipert => e => {
    e.preventDefault();
    let index = e.currentTarget.dataset.index;
    swipert.slideTo(index, 600);
}

const init = content => {
    let triggers = $(content).find('figure a').toArray();
    let swipert = createSwiper();
    let change = changeSlide(swipert);
    triggers.forEach(trigger => {
        trigger.addEventListener('click', change);
    });
};

export default _ => {
    $(document).on('afterShow.fb', function( e, instance, slide ) {
        instance.current.opts.touch.vertical = false;
        instance.current.opts.touch.momentum = false;
        setTimeout(function(){
            init(slide.$slide);
        }, 1000);
    });
}
